import { useMatches } from 'react-router-dom';

export function useIsFullScreenAssistantPage() {
  const matches = useMatches();
  const lastMatch = matches[matches.length - 1];
  return lastMatch?.id === 'workspace_hydra_agent';
}
